import { createFileRoute } from '@tanstack/react-router'
import { ProjectDetailPage } from '@/pages/project-detail'

export const Route = createFileRoute('/_authenticated/projects/$projectId')({
  staticData: { title: 'Project' },
  component: ProjectDetailRoute,
  validateSearch: (search: Record<string, unknown>): { action?: string } => ({
    action: typeof search.action === 'string' ? search.action : undefined,
  }),
})

function ProjectDetailRoute() {
  const { projectId } = Route.useParams()
  const { action } = Route.useSearch()
  return <ProjectDetailPage projectId={projectId} actionUuid={action} />
}
